export enum dataHooks {
  button = 'button',
  prefixIcon = 'prefix-icon',
  suffixIcon = 'suffix-icon',
}
